import { AgentMetaCard, type AgentMetaItem } from "@/pages/agent/components/agent-meta-card";
import { formatAgentDate } from "@/pages/agent/utils/agent-date.utils";
import type { ProjectDetailViewModel } from "@/pages/agent/project/agent-project-page.utils";

export const AgentProjectMetaCard = ({
  projectDetail,
}: {
  projectDetail: ProjectDetailViewModel;
}) => {
  const { project, nextFollowUp, followUpCount } = projectDetail;

  const items: AgentMetaItem[] = [
    {
      label: "Created",
      value: formatAgentDate({ value: project.createdAt, includeTime: true }),
    },
    {
      label: "Updated",
      value: formatAgentDate({ value: project.updatedAt, includeTime: true }),
    },
    {
      label: "Last activity",
      value: project.lastActivityAt
        ? formatAgentDate({ value: project.lastActivityAt, includeTime: true })
        : "—",
    },
    {
      label: "Next follow-up",
      value: nextFollowUp
        ? formatAgentDate({
            value: nextFollowUp.scheduledFor ?? nextFollowUp.dueAt,
            includeTime: true,
          })
        : "None scheduled",
    },
    { label: "Follow-ups", value: String(followUpCount) },
  ];

  return <AgentMetaCard items={items} />;
};
